// extracted by mini-css-extract-plugin
export default {"BlockClientAPIExample":"index__BlockClientAPIExample__dZlAJ","CodeBox":"index__CodeBox__xr4L1"};